import './loadingSpinner.scss';

export const LoadingSpinner = () => {
  return (
    <div className="loading-container">
      <div className="lds-dual-ring" />
    </div>
  );
};
